<template>
    <div>

        <div class="row">
            <div class="col-lg-3">
                <button @click="relatorio('/#/relatorio/periodo?uuid=')" type="button" style="background-color: #e0e0e0" class="btn btn-block right">
                    <img src="https://portal.rastreamos.app/images/relatorios/periodo.png" style="height: 45px"><br/>
                    <h4>RELAT. DE PERÍODO</h4>
                </button>
            </div>

            <div class="col-lg-3">
                <button @click="relatorio('/#/relatorio/deslocamentos?uuid=')" type="button" style="background-color: #e0e0e0" class="btn btn-block  right">
                    <img src="https://portal.rastreamos.app/images/relatorios/deslocamento.png" style="height: 45px"><br/>
                    <h4>RELAT. DE DESLO.</h4>
                </button>
            </div>

            <div class="col-lg-3">
                <button @click="relatorio('/#/relatorio/ignition?uuid=')" type="button" style="background-color: #e0e0e0" class="btn btn-block  right">
                    <img src="https://portal.rastreamos.app/images/relatorios/ignicao.png" style="height: 45px"><br/>
                    <h4>RELAT. DE IGNIÇÃO</h4>
                </button>
            </div>

            <div class="col-lg-3 text-center">
                <button @click="relatorio('/#/relatorio/eventos?uuid=')" type="button" style="background-color: #e0e0e0" class="btn btn-block right">
                    <img src="https://portal.rastreamos.app/images/relatorios/eventos.png" style="height: 45px"><br/>
                    <h4>RELAT. DE EVENTOS</h4>
                </button>
            </div>
        </div>

        <br/>
        <div class="row">
            <div class="col-lg-3">
                <button @click="relatorio('/#/relatorio/garagem?uuid=')" type="button" style="background-color: #e0e0e0" class="btn btn-block right">
                    <img src="https://portal.rastreamos.app/images/cadastros/cerca.png" style="height: 45px"><br/>
                    <h4>RELAT. DE CERCA</h4>
                </button>
            </div>

            <div class="col-lg-3">
                <button @click="relatorio('/#/relatorio/velocidade-excedida?uuid=')" type="button" style="background-color: #e0e0e0" class="btn btn-block right">
                    <img src="https://portal.rastreamos.app/images/relatorios/velocidade_excedida.png" style="height: 45px"><br/>
                    <h4>RELAT. DE VELOCIDADE</h4>
                </button>
            </div>

            <div class="col-lg-3">
                <button @click="relatorio('/#/relatorio/temperatura?uuid=')" type="button" style="background-color: #e0e0e0" class="btn btn-block right">
                    <img src="https://portal.rastreamos.app/images/relatorios/temperatura.png" style="height: 45px"><br/>
                    <h4>RELAT. DE TEMPERATURA</h4>
                </button>
            </div>

            <div class="col-lg-3">
                <button @click="relatorio('/#/relatorio/bloqueio?uuid=')" type="button" style="background-color: #e0e0e0" class="btn btn-block right">
                    <img src="https://portal.rastreamos.app/images/relatorios/bloqueio.png" style="height: 45px"><br/>
                    <h4>RELAT. DE BLOQUEIO</h4>
                </button>
            </div>
        </div>

    </div>
</template>

<script>
    import {Cliente} from '../../class';

    export default {
        name: 'Relatorios',
        props: {
            uuid: {
                default: null
            },
            id_cliente: {
                default: null
            },
        },
        data () {
            return {
                cliente: null
            }
        },
        beforeMount() {
            Cliente.byPKId(this.id_cliente).then((cli) => {
                this.cliente = cli;
            })
        },
        methods: {
            async relatorio (link) {
                swal({
                    title: "Relatório",
                    text: "Abrir o portal deste cliente?",
                    type: "info",
                    showCancelButton: true,
                    preConfirm: () => {
                        let path = link + this.uuid;
                        return Cliente.relatorio(this.cliente.uuid, path);
                    },
                    showLoaderOnConfirm: true
                })
                    .then((dado) => {
                        window.open(dado.url + '/auth/' + dado.token, '__blank');
                    })
                    .catch((err) => {
                        console.log(err);
                    });

            },
        }
    };
</script>
